import { Application } from "./application.js";
function createApplication(rootModule, options) {
    return Application.create(rootModule, options);
}
async function bootstrap(rootModule, options) {
    const app = createApplication(rootModule, options);
    await app.bootstrap();
    return app;
}
export { bootstrap, createApplication };
